import { useCallback } from 'react';

import { CHANNEL } from 'src/data/channel';
import { getContentTypeTag, RESOURCE_CONTENT_TYPE } from 'src/data/performance';
import { cleanUrl } from 'src/lib/url';
import { useErrorHandler, useExtractResource } from 'src/services';
import { usePerformanceActions, useTalkingPointsViewsActions } from 'src/store';

export const useCreateWebsiteAutomationTalkingPointsView = ({ actionsOrigin }) => {
  const performanceActions = usePerformanceActions();
  const extractResource = useExtractResource({ actionsOrigin });
  const talkingPointsViewsActions = useTalkingPointsViewsActions();
  const handleError = useErrorHandler();

  return useCallback(
    async (project) => {
      const urlResources = performanceActions.getUrlResources();
      let resourceId = urlResources.find(
        (resource) => cleanUrl(resource.content || resource.name) === cleanUrl(project.brief.url)
      )?.id;

      try {
        if (!resourceId) {
          const createdResource = await extractResource({
            name: project.brief.url,
            tags: [getContentTypeTag(RESOURCE_CONTENT_TYPE.url)],
            file: null,
            contentType: RESOURCE_CONTENT_TYPE.url,
            url: project.brief.url,
          });
          resourceId = createdResource.id;
        }
        performanceActions.toggleRunningTalkingPointsViewAccountId(resourceId, true);
        await talkingPointsViewsActions.extractTalkingPointsView({
          id: resourceId,
          channel: CHANNEL.other,
        });
      } catch (error) {
        handleError(error);
      } finally {
        performanceActions.toggleRunningTalkingPointsViewAccountId(resourceId, false);
      }
    },
    [performanceActions, talkingPointsViewsActions, handleError, extractResource]
  );
};
